<main role="main" class="maincnt" *ngIf="expiredEnable || enrolledEnable">
  <div class="getbannersect pb-2">
    <div class="col-sm-12 p-0 addaddr">
      <div class="text-center w-100 mb-3">
        <a *ngIf="ShowAddressbutton"
          class="btn sectbtn addrbtn font19"
          href="javascript:void(0)"
         (click) = "addanotheraddress()"
          >ADD ANOTHER ADDRESS</a
        >
      </div>
    </div>
    <div class="sectpad container-fluid graybackgroundclr p-0 pt-4 pb-1">
      <div class="col-sm-6 m-auto p-0 mbwidth">
        <div class="col-12 d-flex p-0">
          <div class="col-6 text-left p-0 pb-4">
            <h5 class="fwgtfive planhead">Plan History</h5>
          </div>
          <div class="col-6 text-right mt-2 pr-0">
            <a
              *ngIf="showSlctAdd"
              class="pikclr planseladd"
              href="javascript:void(0)"
              data-toggle="modal"
              data-target="#addressModal"
              (click)="showAddressModal()"
              >Select Address</a
            >
          </div>
        </div>
        <div *ngIf="enrolledEnable">
          <h3 class="font15 fwgtfive pikclr" *ngIf="enrollplanObj.length > 1">
            ACTIVE PLANS
          </h3>
          <h3 class="font15 fwgtfive pikclr" *ngIf="enrollplanObj.length === 1">
            ACTIVE PLAN
          </h3>
          <div class="">
            <div 
            *ngFor="let singleObj of enrollplanObj; let i = index"
            id="i+1"
            style="margin: 14px 0px 14px 0px"
            >
            <div
              class="plansummary webview othershadw"
           
            
            >
              <div class="d-flex bdrbot align-items-center no-gutters">
                <div class="col-3 text-center img-responsive pt-4">
                  <img
                    src="{{ singleObj.selectedProduct.energy_provider_image }}"
                    alt="{{ selectedProductLogo(singleObj) }}"
                    title="{{ selectedProductLogo(singleObj) }}"
                  />
                  <p class="m-1 font15 font-weight-normal-calibre" id="puctid">
                    PUCT #{{ singleObj.selectedProduct.puct }}
                  </p>
                  <div
                    style="padding-top: 30px"
                    class="pointer"
                    (click)="showSingleObjFilterCard(singleObj._id)"
                  >
                    See Plan Details
                    <mat-icon
                      style="position: absolute"
                      class="pointer"
                      (click)="showSingleObjFilterCard(singleObj._id)"
                      >keyboard_arrow_down</mat-icon
                    >
                  </div>
                </div>
                <div class="col-9">
                  <table class="plansection">
                    <colgroup>
                      <col width="40%" />
                      <col width="20%" />
                      <col width="20%" />
                      <col width="20%" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td class="wd50 pl-2">
                          <div
                            style="font-size: 20px; font-family: 'Calibre-Bold'"
                          >
                            Term:
                            {{ singleObj.selectedProduct.terms }} Months |
                            {{ singleObj.selectedProduct.ProductType }}
                          </div>
                          <p>
                            {{ singleObj.selectedProduct.Renewable }}% Renewable
                          </p>
                        </td>
                        <td class="wd50 pl-2">
                          <div
                            style="font-size: 34px; font-family: 'Calibre-Bold'"
                          >
                            ${{
                              math.round(
                                singleObj.selectedProduct.new_tier
                                  .ave_monthly_bill
                              )
                            }}
                          </div>
                          <p style="margin-top: 5px">Monthly bill estimate</p>
                          <p>
                            for
                            {{
                              math.round(
                                singleObj.selectedProduct.new_tier
                                  .ave_monthly_usage
                              )
                            }}
                            kWh avg usage*
                          </p>
                        </td>
                        <td class="wd50 pl-2">
                          <div
                            style="font-size: 34px; font-family: 'Calibre-Bold'"
                          >
                            {{
                              (
                                singleObj.selectedProduct.new_tier
                                  .ave_price_per_KWH * 100
                              ).toFixed(1) + '¢'
                            }}
                          </div>
                          <p style="margin-top: 5px">
                            Avg Price per
                            {{ singleObj.selectedProduct.energy_units }}*
                          </p>
                          <p>
                            (${{
                              math.round(
                                singleObj.selectedProduct.new_tier
                                  .ave_monthly_bill
                              )
                            }}
                            <span>&#247;</span
                            >{{
                              math.round(
                                singleObj.selectedProduct.new_tier
                                  .ave_monthly_usage
                              )
                            }}kWh)
                          </p>
                        </td>
                        <td class="wd50 wrdbrk pl-2">
                          <p
                            class="fwgtsix"
                            style="
                              font-size: 40px;
                              font-family: 'Calibre-Bold';
                              color: deeppink;
                              line-height: 29px;
                            "
                          >
                            {{
                              (
                                singleObj.selectedProduct.new_tier
                                  .ave_price_per_KWH * 100
                              ).toFixed(1) + '¢'
                            }}
                          </p>
                          <p class="font-weight-normal-calibre wrdbrk">
                            per Kwh
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="plan webview align-items-center pt-2 pb-1">
                    <div class="plandesc col">
                      <span style="font-size: 20px; font-weight: 600">{{
                        singleObj.selectedProduct.product_key
                      }}</span>
                      <p
                        class="font-weight-normal-calibre text-left"
                        [innerHTML]="singleObj.selectedProduct.description"
                      ></p>
                    </div>
                    <div class="col col-auto webview text-center">
                      <!-- <a
                        class="
                          btn
                          signup
                          font18
                          font-weight-bold-calibre
                          sectbtnhvr
                        "
                        (click)="orderProduct(singleObj)"
                        >SIGN ME UP</a
                      ><br /> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="webview" *ngIf="showSingleObjDetails && singleObj._id == currentid">
                <div
                  style="
                    background: #e2e2e2;
                    font-family: 'Calibre-SemiBold';
                    font-size: 15px;
                    margin-top: 10px;
                  "
                >
                  Plan Details
                </div>
                <div class="d-flex">
                  <div class="col-3" style="max-width: 10% !important">
                    <div class="d-flex">
                      <div class="">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="pikclr pt-1 pl-1"
                          href="{{ singleObj.selectedProduct.productEFL }}"
                          target="_blank"
                          >EFL</a
                        >
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="float-left">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="pikclr pt-1 pl-1"
                          href="{{ singleObj.productTOS }}"
                          target="_blank"
                          >TOS</a
                        >
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="float-left">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="pikclr pt-1 pl-1"
                          href="{{ singleObj.productYRAC }}"
                          target="_blank"
                          >YRAC</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="">
                      <span
                        style="font-size: 14px; font-family: 'Calibre-SemiBold'"
                        >Early Cancellation Fee</span
                      ><br />
                      <span>
                        ${{ singleObj.selectedProduct.cancellation_fee }} per
                        month remaining on contract. Note: this fee will not
                        apply if you move and provide a forwarding address
                        verifying the move.
                      </span>
                    </div>
                    <div class="">
                      <span
                        style="font-size: 14px; font-family: 'Calibre-SemiBold'"
                        >Pricing Details</span
                      >
                      <div>
                        <table class="plantbl text-center">
                          <thead>
                            <th class="fwgtthree" width="28%">Monthly Usage</th>
                            <th
                              *ngFor="
                                let usageObj of singleObj.selectedProduct.tier
                              "
                              class="
                                tabpad
                                brdrgtblk
                                font-weight-normal-calibre
                                fwgtthree
                              "
                            >
                              {{ math.round(usageObj.usage) }} kWh
                            </th>
                            <th
                              class="radius2 last-th font-weight-bold-calibre"
                            >
                              <span class=""></span
                              >{{
                                math.round(singleObj.selectedProduct.new_tier
                                  .ave_monthly_usage)
                              }}
                              kWh
                            </th>
                          </thead>
                          <tbody>
                            <td
                              class="tabpadd radius4 brdrgtblk semi-bold"
                              style="background-color: #e2e2e2 !important"
                            >
                              Average Price per kWh
                            </td>
                            <td
                              *ngFor="
                                let usageObj of singleObj.selectedProduct.tier
                              "
                              class="tabpadd brdrgtblk semi-bold"
                            >
                              {{ (usageObj.avg_charge * 100).toFixed(1)
                              }}<span>&#162;</span>
                            </td>
                            <td
                              class="tabpadd radius3 last-th pdfclr semi-bold"
                            >
                              {{
                                singleObj
                                  ? (
                                      singleObj.selectedProduct.new_tier
                                        .ave_price_per_KWH * 100
                                    ).toFixed(1)
                                  : '-'
                              }}¢<font class="fwgtthree">Your Avg&#42;</font>
                            </td>
                          </tbody>
                        </table>
                      </div>
                      <div>
                        <span style="font-family: 'Calibre-SemiBold'"
                          >Here’s how the charges are calculated:</span
                        >
                        <p>
                          Energy Charge:
                          {{ singleObj.selectedProduct.energy_charge }} cents
                          per kWh (1 - 2000 kWh)
                        </p>
                        <p style="line-height: 6px">
                          Base Charge: ${{ singleObj.selectedProduct.base_fee }}
                          per billing cycle
                        </p>
                        <p>
                          TDU Meter Charge/Month: ${{
                            singleObj.selectedProduct
                              .tdu_delivery_charge_per_kwh
                          }}
                        </p>
                        <p style="line-height: 6px">
                          TDU Delivery Charge:
                          {{ singleObj.selectedProduct.tdu_delivery_charge }}
                          cents per kWh
                        </p>
                        <p style="padding-top: 10px">
                          Avg. Price per kWh = ({{
                            singleObj.selectedProduct.energy_provider
                          }}
                          + TDU Charges) / Total Monthly Usage
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            


            </div>
            <div style="background-color: white" class="mobileview">
              
            <div class="col-sm-9 col-md-10 col-lg-10 p-0 ">
              <table class="plansection ">
                <colgroup>
                  <col width="40%" />
                  <col width="20%" />
                  <col width="20%" />
                  <col width="20%" />
                </colgroup>
                <tbody style="border:2px solid #ed1976; border-bottom: 0px;">
                  <tr>
                    <td
                      class="
                        bdrbotgry
                        bdrrgtgry
                        bdrrgtwhite
                        position-relative
                      "
                    >
                      <div class="w-50 float-left pr-2 mblogo">
                        <img src="{{ singleObj.selectedProduct.energy_provider_image  }}" />
                        <p
                          class="m-1 font15 font-weight-normal-calibre"
                          id="puctid"
                        >
                          PUCT #{{ singleObj.selectedProduct.puct }}
                        </p>
                      </div>
                      <div class="mob-pl-0 w-50 float-left pl-2">
                        <p class="fwgtsix text-left">Energy Provider</p>
                        <p
                          class="font-weight-normal-calibre wrdbrk text-left"
                        >
                          {{ singleObj.selectedProduct.energy_provider }}
                        </p>
                      </div>
                    </td>
                    <td class="bdrbotgry pl-2 bdrrgtgry bdrrgtwhite">
                      <p class="fwgtsix text-left">Plan Name</p>
                      <p class="font-weight-normal-calibre wrdbrk text-left">
                        {{ singleObj.selectedProduct.product_key }}
                      </p>
                    </td>
                    <td class="bdrbotgry bdrrgtgry wd50 pl-2">
                      <p class="fwgtsix text-left">Term</p>
                      <p class="font-weight-normal-calibre wrdbrk text-left">
                        {{ singleObj.selectedProduct.terms }} Months
                        {{ singleObj.selectedProduct.categoryName }}
                      </p>
                    </td>
                    <td class="bdrbotgry wd50 wrdbrk pl-2">
                      <p class="fwgtsix text-left">Early Cancellation Fee</p>
                      <p
                        class="font-weight-normal-calibre wrdbrk text-left"
                        *ngIf="singleObj.selectedProduct.ETF && singleObj.selectedProduct.ETFTypeId != 2"
                      >
                        ${{ singleObj.selectedProduct.ETF }} <br /><br />
                      </p>
                      <p
                        class="font-weight-normal-calibre wrdbrk text-left"
                        *ngIf="singleObj.selectedProduct.ETF && singleObj.selectedProduct.ETFTypeId === 2"
                      >
                        ${{ singleObj.selectedProduct.ETF }} per month remaining <br /><br />
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
             
           
            </div>
            <div style="border:2px solid #ed1976; border-top: 0px;border-bottom: 0px;" class="plan">
              <div class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2">
                <p class="fwgtsix">Description</p>
                <p
                  class="font-weight-normal-calibre"
                  [innerHTML]="singleObj.selectedProduct.description"
                ></p>
              </div>
              <div class="col-sm-8 col-md-8 col-lg-8 pt-2">
                <p class="fwgtsix text-left font15 lnhgt15">Pricing Details</p>
                <table class="plantbl text-center">
                  
                  <thead>
                    <th class="fwgtthree" width="28%">Monthly Usage</th>
                    <th
                      *ngFor="
                        let usageObj of singleObj.selectedProduct.tier
                      "
                      class="
                        tabpad
                        brdrgtblk
                        font-weight-normal-calibre
                        fwgtthree
                      "
                    >
                      {{ math.round(usageObj.usage) }} kWh
                    </th>
                    <th
                      class="radius2 last-th font-weight-bold-calibre"
                    >
                      <span class=""></span
                      >{{
                        math.round(singleObj.selectedProduct.new_tier
                          .ave_monthly_usage)
                      }}
                      kWh
                    </th>
                  </thead>
                  <tbody>
                    <td
                      class="tabpadd radius4 brdrgtblk semi-bold"
                      style="background-color: #e2e2e2 !important"
                    >
                      Average Price per kWh
                    </td>
                    <td
                      *ngFor="
                        let usageObj of singleObj.selectedProduct.tier
                      "
                      class="tabpadd brdrgtblk semi-bold"
                    >
                      {{ (usageObj.avg_charge * 100).toFixed(1)
                      }}<span>&#162;</span>
                    </td>
                    <td
                      class="tabpadd radius3 last-th pdfclr semi-bold"
                    >
                      {{
                        singleObj
                          ? (
                              singleObj.selectedProduct.new_tier
                                .ave_price_per_KWH * 100
                            ).toFixed(1)
                          : '-'
                      }}¢<font class="fwgtthree">Your Avg&#42;</font>
                    </td>
                  </tbody>
                </table>
              </div>
            </div>
            <div style="border:2px solid #ed1976; border-top: 0px"class="">
              <div class="d-flex p-3">
                

                <div
                  class="col-4 d-flex flex-row pl-0 text-left"
                  *ngIf="singleObj.selectedProduct.Renewable"
                >
                  <div class="float-left mr-1">
                    <img
                      src="assets/images/leaf.png"
                      alt="Green leaf to signify renewable energy percentage for each product"
                      title="Renewable Energy Green Leaf"
                      width="18"
                    />
                  </div>
                  <div>
                    <a class="float-left pikclr pt-1 pl-1" target="_blank"
                      >{{ singleObj.selectedProduct.Renewable }}% Renewable Energy</a
                    >
                  </div>
                </div>

                <div class="col-2 d-flex flex-row pl-0 text-left">
                  <div class="float-left mr-1">
                    <img src="assets/images/pdf.svg" width="18" />
                  </div>
                  <div>
                    <a
                      class="float-left pikclr pt-1 pl-1"
                      href="{{ singleObj.selectedProduct.productEFL }}"
                      target="_blank"
                      >EFL</a
                    >
                  </div>
                </div>

                <div
                  class="col-4 d-flex flex-row flexauto forallmore text-left"
                >
                  <div class="float-left mr-1">
                    <img src="assets/images/pdf.svg" width="18" />
                  </div>
                  <div>
                    <a
                      class="float-left pikclr pt-1 pl-1"
                      href="{{ singleObj.selectedProduct.productTOS }}"
                      target="_blank"
                      >TOS</a
                    >
                  </div>
                </div>
                <div
                  class="
                    col-4
                    d-flex
                    flex-row
                    flexauto
                    forallmore
                    pr-0
                    text-left
                  "
                >
                  <div class="float-left mr-1">
                    <img src="assets/images/pdf.svg" width="18" />
                  </div>
                  <div>
                    <a
                      class="float-left pikclr pt-1 pl-1"
                      href="{{ singleObj.selectedProduct.productYRAC }}"
                      target="_blank"
                      >YRAC</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
            <p
            class="
              font-weight-normal-calibre
              font15
              lnhgt15
              
              mt-1
            "
            style="padding-bottom: 5px"
          >
              Service Address:
              {{
                singleObj.billingAddress.userAddress.street_address +
                  ' ' +
                  (singleObj.billingAddress.apartment
                    ? 'APT ' + singleObj.billingAddress.apartment
                    : '') +
                  ',' +
                  ' ' +
                  singleObj.billingAddress.userAddress.city +
                  ',' +
                  ' ' +
                  singleObj.billingAddress.userAddress.state +
                  ' ' +
                  singleObj.billingAddress.userAddress.zipcode
              }}
              | ESIID: {{ singleObj.esiid }}<br />
              Contract Term:
              {{ isDate(singleObj.serviceTypeDetails.switchDate) ? (singleObj.serviceTypeDetails.switchDate | date: 'M/d/yyyy') : (singleObj.createdDate | date: 'M/d/yyyy') }} -
              {{ singleObj.expirationDate | date: 'M/d/yyyy' }}*
            </p>
            </div>

            <!-- <div class="mt-4">
              <table class="mb-2 tbllayout">
                <tr *ngFor="let singleObj of enrollplanObj">
                  <div class="plansummary mb-3">
                    <div class="d-flex bdrbot pr-0">
                      <div
                        class="
                          col-4 col-sm-3 col-md-2 col-lg-2
                          mob-pt-5
                          py-3
                          planrate
                          text-center
                        "
                      >
                        <div class="minhgt50p rateamt brdbottom">
                          <div class="w-100">
                            <h1 class="clrpink fwgtsix pikclr avgvalue">
                              {{
                                (
                                  singleObj.selectedProduct.new_tier
                                    .ave_price_per_KWH * 100
                                ).toFixed(1)
                              }}¢
                            </h1>
                            <p style="line-height: 13px">Avg. Price per kWh*</p>
                          </div>
                        </div>
                        <div class="minhgt50p rateamt">
                          <div class="w-100">
                            <h1 class="fwgtsix rate mt-0 mob-pt-5 avgvalue">
                              {{ singleObj.selectedProduct.price_units
                              }}{{
                                math.round(
                                  singleObj.selectedProduct.new_tier
                                    .ave_monthly_bill
                                )
                              }}
                            </h1>
                            <p style="line-height: 13px">
                              Monthly Bill Estimate
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 col-md-10 col-lg-10 p-0">
                        <table class="plansection">
                          <colgroup>
                            <col width="40%" />
                            <col width="20%" />
                            <col width="20%" />
                            <col width="20%" />
                          </colgroup>
                          <tbody>
                            <tr>
                              <td
                                class="
                                  bdrbotgry
                                  bdrrgtgry
                                  bdrrgtwhite
                                  position-relative
                                "
                                style="padding-top: 8px !important"
                              >
                                <div class="mob-pl-0">
                                  <img
                                    src="{{
                                      singleObj.selectedProduct
                                        .energy_provider_image
                                    }}"
                                    alt="{{ selectedProductLogo(singleObj) }}"
                                    title="{{ selectedProductLogo(singleObj) }}"
                                  />
                                </div>

                                <div class="pr-2 mblogo">
                                  <p
                                    class="
                                      m-1
                                      font15
                                      font-weight-normal-calibre
                                      puctid
                                    "
                                  >
                                    PUCT #{{ singleObj.selectedProduct.puct }}
                                  </p>
                                </div>
                              </td>
                              <td class="bdrbotgry pl-2 bdrrgtgry bdrrgtwhite">
                                <p class="fwgtsix text-left">Plan Name</p>
                                <p
                                  class="
                                    font-weight-normal-calibre
                                    wrdbrk
                                    text-left
                                  "
                                >
                                  {{ singleObj.selectedProduct.product_key }}
                                </p>
                              </td>
                              <td class="bdrbotgry bdrrgtgry wd50 pl-2">
                                <p class="fwgtsix text-left">Term</p>
                                <p
                                  class="
                                    font-weight-normal-calibre
                                    wrdbrk
                                    text-left
                                  "
                                >
                                  {{ singleObj.selectedProduct.terms }} Months
                                  {{ singleObj.selectedProduct.categoryName }}
                                </p>
                              </td>
                              <td class="bdrbotgry wd50 wrdbrk pl-2">
                                <p class="fwgtsix text-left">
                                  Early Cancellation
                                </p>
                                <p
                                  class="
                                    font-weight-normal-calibre
                                    wrdbrk
                                    text-left
                                  "
                                  *ngIf="
                                    singleObj.selectedProduct.cancellation_fee >
                                    0
                                  "
                                >
                                  ${{
                                    singleObj.selectedProduct.cancellation_fee
                                  }}
                                </p>

                                <p
                                  class="
                                    font-weight-normal-calibre
                                    wrdbrk
                                    text-left
                                  "
                                  *ngIf="
                                    singleObj.selectedProduct
                                      .cancellation_fee == 0 &&
                                    singleObj.selectedProduct.ETF &&
                                    singleObj.selectedProduct.ETFTypeId != 2
                                  "
                                >
                                  ${{ singleObj.selectedProduct.ETF }}
                                </p>
                                <p
                                  class="
                                    font-weight-normal-calibre
                                    wrdbrk
                                    text-left
                                  "
                                  *ngIf="
                                    singleObj.selectedProduct
                                      .cancellation_fee == 0 &&
                                    singleObj.selectedProduct.ETF &&
                                    singleObj.selectedProduct.ETFTypeId === 2
                                  "
                                >
                                  ${{ singleObj.selectedProduct.ETF }} per month
                                  remaining
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="plan webview">
                          <div class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2">
                            <p class="fwgtsix text-left">Description</p>
                            <p
                              class="font-weight-normal-calibre text-left"
                              [innerHTML]="
                                singleObj.selectedProduct.description
                              "
                            ></p>
                          </div>
                          <div class="col-sm-8 col-md-8 col-lg-8 pt-2">
                            <p class="fwgtsix text-left font15 lnhgt15">
                              Pricing Details
                            </p>
                            <table class="plantbl text-center">
                              <thead>
                                <th class="fwgtthree" width="28%">
                                  Monthly Usage
                                </th>
                                <th
                                  *ngFor="
                                    let usageObj of singleObj.selectedProduct
                                      .tier
                                  "
                                  class="
                                    tabpad
                                    brdrgtblk
                                    font-weight-normal-calibre
                                    fwgtthree
                                  "
                                >
                                  {{ usageObj.usage }} kWh
                                </th>
                                <th
                                  class="
                                    radius2
                                    last-th
                                    font-weight-bold-calibre
                                  "
                                >
                                  <span class=""></span
                                  >{{
                                    singleObj.selectedProduct.new_tier
                                      .ave_monthly_usage
                                  }}
                                  kWh
                                </th>
                              </thead>
                              <tbody>
                                <td class="tabpadd radius4 brdrgtblk semi-bold">
                                  Average Price per kWh
                                </td>
                                <td
                                  *ngFor="
                                    let usageObj of singleObj.selectedProduct
                                      .tier
                                  "
                                  class="tabpadd brdrgtblk semi-bold"
                                >
                                  {{ (usageObj.avg_charge * 100).toFixed(1)
                                  }}<span>&#162;</span>
                                </td>
                                <td
                                  class="
                                    tabpadd
                                    radius3
                                    last-th
                                    pdfclr
                                    semi-bold
                                  "
                                >
                                  {{
                                    (
                                      singleObj.selectedProduct.new_tier
                                        .ave_price_per_KWH * 100
                                    ).toFixed(1)
                                  }}¢<font class="fwgtthree"
                                    >Your Avg&#42;</font
                                  >
                                </td>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="webview">
                          <div class="d-flex mt-1 p-2">
                            <div
                              class="col-sm-4 col-md-4 col-lg-4 pt-2 pl-2"
                              *ngIf="!singleObj.selectedProduct.Renewable"
                            >
                              <img
                                src=""
                                width="18"
                                style="display: none"
                              />&nbsp;<a
                                class="pikclr pull-left"
                                target="_blank"
                              >
                                4% Renewable Energy
                              </a>
                            </div>

                            <div
                              class="col-sm-4 col-md-4 col-lg-4 pt-2 pl-2"
                              *ngIf="singleObj.selectedProduct.Renewable"
                            >
                              <img
                                src="assets/images/leaf.png"
                                alt="Green leaf to signify renewable energy percentage for each product"
                                title="Renewable Energy Green Leaf"
                                width="18"
                              />&nbsp;<a class="pikclr pl-0" target="_blank"
                                >{{ singleObj.selectedProduct.Renewable }}%
                                Renewable Energy
                              </a>
                            </div>
                            <div class="col-sm-8 col-md-8 col-lg-8 pt-2">
                              <div class="d-flex flex-row">
                                <div
                                  class="
                                    col-5
                                    flexauto
                                    forallmore
                                    pl-0
                                    text-left
                                  "
                                >
                                  <img
                                    src="assets/images/pdf.svg"
                                    width="18"
                                  />&nbsp;<a
                                    class="pikclr pl-1"
                                    href="{{
                                      singleObj.selectedProduct.productEFL
                                    }}"
                                    target="_blank"
                                    >Electricity Facts Label</a
                                  >
                                </div>
                                <div
                                  class="col-5 flexauto forallmore text-left"
                                >
                                  <img
                                    src="assets/images/pdf.svg"
                                    width="18"
                                  />&nbsp;<a
                                    class="pikclr pl-1"
                                    href="{{
                                      singleObj.selectedProduct.productTOS
                                    }}"
                                    target="_blank"
                                    >TOS</a
                                  >
                                </div>
                                <div
                                  class="
                                    col-2
                                    flexauto
                                    forallmore
                                    pr-0
                                    text-left
                                  "
                                >
                                  <img
                                    src="assets/images/pdf.svg"
                                    width="18"
                                  />&nbsp;<a
                                    class="pikclr pl-1"
                                    href="{{
                                      singleObj.selectedProduct.productYRAC
                                    }}"
                                    target="_blank"
                                    >YRAC</a
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="plan mobileview">
                        <div class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2">
                          <p class="fwgtsix">Description</p>
                          <p
                            class="font-weight-normal-calibre"
                            [innerHTML]="singleObj.selectedProduct.description"
                          ></p>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 pt-2">
                          <p class="fwgtsix text-left font15 lnhgt15">
                            Pricing Details
                          </p>
                          <table class="plantbl text-center">
                            <thead>
                              <th class="fwgtthree" width="28%">
                                Monthly Usage
                              </th>
                              <th
                                *ngFor="
                                  let usageObj of singleObj.selectedProduct.tier
                                "
                                class="
                                  tabpad
                                  brdrgtblk
                                  font-weight-normal-calibre
                                  fwgtthree
                                "
                              >
                                {{ usageObj.usage }} kWh
                              </th>
                              <th
                                class="radius2 last-th font-weight-bold-calibre"
                              >
                                <span class=""></span
                                >{{
                                  singleObj.selectedProduct.new_tier
                                    .ave_monthly_usage
                                }}
                                kWh
                              </th>
                            </thead>
                            <tbody>
                              <td class="tabpadd radius4 brdrgtblk semi-bold">
                                Average Price per kWh
                              </td>
                              <td
                                *ngFor="
                                  let usageObj of singleObj.selectedProduct.tier
                                "
                                class="tabpadd brdrgtblk semi-bold"
                              >
                                {{ (usageObj.avg_charge * 100).toFixed(1)
                                }}<span>&#162;</span>
                              </td>
                              <td
                                class="tabpadd radius3 last-th pdfclr semi-bold"
                              >
                                {{
                                  (
                                    singleObj.selectedProduct.new_tier
                                      .ave_price_per_KWH * 100
                                  ).toFixed(1)
                                }}¢<font class="fwgtthree">Your Avg&#42;</font>
                              </td>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="mobileview">
                        <div class="d-flex mt-1 p-3 mb-2">
                          <div
                            class="col-4 d-flex flex-row pl-0 text-left"
                            *ngIf="!singleObj.selectedProduct.Renewable"
                          >
                            <div class="float-left mr-1">
                              <img src="" width="18" />
                            </div>
                            <div>
                              <a class="float-left pikclr pt-1" target="_blank"
                                >4% Renewable Energy</a
                              >
                            </div>
                          </div>

                          <div
                            class="col-4 d-flex flex-row pl-0 text-left"
                            *ngIf="singleObj.selectedProduct.Renewable"
                          >
                            <div class="float-left mr-1">
                              <img
                                src="assets/images/leaf.png"
                                alt="Green leaf to signify renewable energy percentage for each product"
                                title="Renewable Energy Green Leaf"
                                width="18"
                              />
                            </div>
                            <div>
                              <a
                                class="float-left pikclr pt-1 pl-1"
                                target="_blank"
                                >{{ singleObj.selectedProduct.Renewable }}%
                                Renewable Energy</a
                              >
                            </div>
                          </div>

                          <div class="col-2 d-flex flex-row pl-0 text-left">
                            <div class="float-left mr-1">
                              <img src="assets/images/pdf.svg" width="18" />
                            </div>
                            <div>
                              <a
                                class="float-left pikclr pt-1 pl-1"
                                href="{{
                                  singleObj.selectedProduct.productEFL
                                }}"
                                target="_blank"
                                >EFL</a
                              >
                            </div>
                          </div>

                          <div
                            class="
                              col-4
                              d-flex
                              flex-row
                              flexauto
                              forallmore
                              text-left
                            "
                          >
                            <div class="float-left mr-1">
                              <img src="assets/images/pdf.svg" width="18" />
                            </div>
                            <div>
                              <a
                                class="float-left pikclr pt-1 pl-1"
                                href="{{
                                  singleObj.selectedProduct.productTOS
                                }}"
                                target="_blank"
                                >TOS</a
                              >
                            </div>
                          </div>
                          <div
                            class="
                              col-4
                              d-flex
                              flex-row
                              flexauto
                              forallmore
                              pr-0
                              text-left
                            "
                          >
                            <div class="float-left mr-1">
                              <img src="assets/images/pdf.svg" width="18" />
                            </div>
                            <div>
                              <a
                                class="float-left pikclr pt-1 pl-1"
                                href="{{
                                  singleObj.selectedProduct.productYRAC
                                }}"
                                target="_blank"
                                >YRAC</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p
                      class="
                        font-weight-normal-calibre
                        font15
                        lnhgt15
                        webview
                        mt-3
                      "
                      style="padding-bottom: 5px"
                    >
                      Service Address:
                      {{
                        singleObj.billingAddress.userAddress.street_address +
                          ' ' +
                          (singleObj.billingAddress.apartment
                            ? 'APT ' + singleObj.billingAddress.apartment
                            : '') +
                          ',' +
                          ' ' +
                          singleObj.billingAddress.userAddress.city +
                          ',' +
                          ' ' +
                          singleObj.billingAddress.userAddress.state +
                          ' ' +
                          singleObj.billingAddress.userAddress.zipcode
                      }}
                      | ESI ID: {{ singleObj.esiid }}<br />
                      Contract Term:
                      {{ singleObj.createdDate | date: 'M/d/yyyy' }} -
                      {{ singleObj.expirationDate | date: 'M/d/yyyy' }}*
                    </p>
                    <p
                      class="
                        font-weight-normal-calibre
                        font15
                        lnhgt15
                        mobileview
                        mt-3
                      "
                      style="padding-bottom: 5px"
                    >
                      Service Address:
                      {{
                        singleObj.billingAddress.userAddress.street_address +
                          ' ' +
                          (singleObj.billingAddress.apartment
                            ? 'APT ' + singleObj.billingAddress.apartment
                            : '') +
                          ',' +
                          ' ' +
                          singleObj.billingAddress.userAddress.city +
                          ',' +
                          ' ' +
                          singleObj.billingAddress.userAddress.state +
                          ' ' +
                          singleObj.billingAddress.userAddress.zipcode
                      }}
                      <br />
                      ESI ID: {{ singleObj.esiid }}<br />
                      Contract Term:
                      {{ singleObj.createdDate | date: 'M/d/yyyy' }} -
                      {{ singleObj.expirationDate | date: 'M/d/yyyy' }}*
                    </p>
                  </div>
                </tr>
              </table>
            </div> -->
          </div>
        </div>
        <div class="mt-4" *ngIf="expiredEnable">
          <h3 class="font15 fwgtfive">PREVIOUS PLAN</h3>
          <div class="plansummary">
            <div class="d-flex bdrbot pr-0">
              <div
                class="
                  col-4 col-sm-3 col-md-2 col-lg-2
                  mob-pt-5
                  py-3
                  planrate
                  text-center
                "
              >
                <div class="minhgt50p rateamt brdbottom">
                  <div class="w-100">
                    <h1 class="clrpink fwgtsix pikclr expavgvalue">
                      {{ expired_averagePrice.toFixed(1) }}¢
                    </h1>
                    <p style="line-height: 13px">Avg. Price per kWh*</p>
                  </div>
                </div>
                <div class="minhgt50p rateamt">
                  <div class="w-100">
                    <h1 class="fwgtsix rate mt-0 mob-pt-5 expavgvalue">
                      ${{ math.round(expiredPlan.new_tier.ave_monthly_bill) }}
                    </h1>
                    <p style="line-height: 13px">Monthly Bill Estimate</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-9 col-md-10 col-lg-10 p-0">
                <table class="plansection">
                  <colgroup>
                    <col width="40%" />
                    <col width="20%" />
                    <col width="20%" />
                    <col width="20%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td
                        class="
                          bdrbotgry
                          bdrrgtgry
                          bdrrgtwhite
                          position-relative
                        "
                      >
                        <div class="w-50 float-left pr-2 mblogo">
                          <img src="{{ expiredPlan.energy_provider_image }}" />
                          <p
                            class="m-1 font15 font-weight-normal-calibre"
                            id="puctid"
                          >
                            PUCT #{{ expiredPlan.puct }}
                          </p>
                        </div>
                        <div class="mob-pl-0 w-50 float-left pl-2">
                          <p class="fwgtsix text-left">Energy Provider</p>
                          <p
                            class="font-weight-normal-calibre wrdbrk text-left"
                          >
                            {{ expiredPlan.energy_provider }}
                          </p>
                        </div>
                      </td>
                      <td class="bdrbotgry pl-2 bdrrgtgry bdrrgtwhite">
                        <p class="fwgtsix text-left">Plan Name</p>
                        <p class="font-weight-normal-calibre wrdbrk text-left">
                          {{ expiredPlan.product_key }}
                        </p>
                      </td>
                      <td class="bdrbotgry bdrrgtgry wd50 pl-2">
                        <p class="fwgtsix text-left">Term</p>
                        <p class="font-weight-normal-calibre wrdbrk text-left">
                          {{ expiredPlan.terms }} Months
                          {{ expiredPlan.categoryName }}
                        </p>
                      </td>
                      <td class="bdrbotgry wd50 wrdbrk pl-2">
                        <p class="fwgtsix text-left">Early Cancellation Fee</p>
                        <p
                          class="font-weight-normal-calibre wrdbrk text-left"
                          *ngIf="expiredPlan.cancellation_fee && expiredPlan.ETFTypeId != 2"
                        >
                          ${{ expiredPlan.cancellation_fee }} <br />
                        </p>
                        <p
                          class="font-weight-normal-calibre wrdbrk text-left"
                          *ngIf="expiredPlan.cancellation_fee && expiredPlan.ETFTypeId === 2"
                        >
                          ${{ expiredPlan.cancellation_fee }} per month remaining
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="plan webview">
                  <div class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2">
                    <p class="fwgtsix">Description</p>
                    <p
                      class="font-weight-normal-calibre"
                      [innerHTML]="expiredPlan.description"
                    ></p>
                  </div>
                  <div class="col-sm-8 col-md-8 col-lg-8 pt-2">
                    <p class="fwgtsix text-left font15 lnhgt15">
                      Pricing Details
                    </p>
                    <table class="plantbl text-center">
                      <thead>
                        <th class="fwgtthree" width="28%">Monthly Usage</th>
                        <th class="fwgtthree">500 kWh</th>
                        <th class="fwgtthree">1000 kWh</th>
                        <th class="fwgtthree">2000 kWh</th>
                        <th class="fwgtthree bold">
                          {{ expired_avgMthlyUsage }} kWh
                        </th>
                      </thead>
                      <tbody>
                        <td class="semi-bold" width="28%">
                          Average Price per kWh
                        </td>
                        <td class="semi-bold">{{ expired_t1_avg_charge }}¢</td>
                        <td class="semi-bold">{{ expired_t2_avg_charge }}¢</td>
                        <td class="semi-bold">{{ expired_t3_avg_charge }}¢</td>
                        <td class="semi-bold">
                          {{ expired_averagePrice.toFixed(1) }}¢
                          <font class="fwgtthree">Your Avg&#42;</font>
                        </td>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="webview">
                  <div class="d-flex mt-1 p-2">
                    <div
                      class="
                        col-md-5
                        ml-2
                        pr-4
                        flexauto
                        forallmore
                        pl-0
                        text-left
                        mt-1
                      "
                      style="padding-left: 1px !important"
                      *ngIf="!expiredPlan.Renewable"
                    >
                      <img src="" width="18" style="display: none" />&nbsp;<a
                        class="pikclr pull-left"
                        target="_blank"
                      >
                        4% Renewable Energy
                      </a>
                    </div>

                    <div
                      class="
                        col-md-5
                        ml-2
                        pr-0
                        flexauto
                        forallmore
                        pl-0
                        text-left
                      "
                      style="padding-left: 1px !important"
                      *ngIf="expiredPlan.Renewable"
                    >
                      <img
                        src="assets/images/leaf.png"
                        alt="Green leaf to signify renewable energy percentage for each product"
                        title="Renewable Energy Green Leaf"
                        width="18"
                      />&nbsp;<a class="pikclr pl-0" target="_blank"
                        >{{ expiredPlan.Renewable }}% Renewable Energy
                      </a>
                    </div>

                    <div
                      class="
                        d-flex
                        flex-row
                        pl-1
                        text-right
                        pull-right
                        offset-md-1
                      "
                      style="padding-left: 47px !important"
                    >
                      <div class="col-5 flexauto forallmore pl-0 text-left">
                        <img src="assets/images/pdf.svg" width="18" />&nbsp;<a
                          class="pikclr pl-1"
                          href="{{ expiredPlan.productEFL }}"
                          target="_blank"
                          >Electricity Facts Label</a
                        >
                      </div>
                      <div class="col-5 flexauto forallmore text-left">
                        <img src="assets/images/pdf.svg" width="18" />&nbsp;<a
                          class="pikclr pl-1"
                          href="{{ expiredPlan.productTOS }}"
                          target="_blank"
                          >TOS</a
                        >
                      </div>
                      <div class="col-2 flexauto forallmore pr-0 text-left">
                        <img src="assets/images/pdf.svg" width="18" />&nbsp;<a
                          class="pikclr pl-1"
                          href="{{ expiredPlan.productYRAC }}"
                          target="_blank"
                          >YRAC</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="plan mobileview">
              <div class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2">
                <p class="fwgtsix">Description</p>
                <p
                  class="font-weight-normal-calibre"
                  [innerHTML]="expiredPlan.description"
                ></p>
              </div>
              <div class="col-sm-8 col-md-8 col-lg-8 pt-2">
                <p class="fwgtsix text-left font15 lnhgt15">Pricing Details</p>
                <table class="plantbl text-center">
                  <thead>
                    <th class="fwgtthree" width="28%">Monthly Usage</th>
                    <th class="fwgtthree">500 kWh</th>
                    <th class="fwgtthree">1000 kWh</th>
                    <th class="fwgtthree">2000 kWh</th>
                    <th class="fwgtthree bold">567 kWh</th>
                  </thead>
                  <tbody>
                    <td class="text-center" width="28%">Average</td>
                    <td>{{ expired_t1_avg_charge }}¢</td>
                    <td>{{ expired_t2_avg_charge }}¢</td>
                    <td>{{ expired_t3_avg_charge }}¢</td>
                    <td>
                      {{ expired_averagePrice.toFixed(1) }}¢<font
                        >Your Avg&#42;</font
                      >
                    </td>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="mobileview">
              <div class="d-flex mt-1 p-3">
                <div
                  class="col-4 d-flex flex-row pl-0 text-left"
                  *ngIf="!expiredPlan.Renewable"
                >
                  <div class="float-left mr-1"><img src="" width="18" /></div>
                  <div>
                    <a class="float-left pikclr pt-1" target="_blank"
                      >4% Renewable Energy</a
                    >
                  </div>
                </div>

                <div
                  class="col-4 d-flex flex-row pl-0 text-left"
                  *ngIf="expiredPlan.Renewable"
                >
                  <div class="float-left mr-1">
                    <img
                      src="assets/images/leaf.png"
                      alt="Green leaf to signify renewable energy percentage for each product"
                      title="Renewable Energy Green Leaf"
                      width="18"
                    />
                  </div>
                  <div>
                    <a class="float-left pikclr pt-1 pl-1" target="_blank"
                      >{{ expiredPlan.Renewable }}% Renewable Energy</a
                    >
                  </div>
                </div>

                <div class="col-2 d-flex flex-row pl-0 text-left">
                  <div class="float-left mr-1">
                    <img src="assets/images/pdf.svg" width="18" />
                  </div>
                  <div>
                    <a
                      class="float-left pikclr pt-1 pl-1"
                      href="{{ expiredPlan.productEFL }}"
                      target="_blank"
                      >EFL</a
                    >
                  </div>
                </div>

                <div
                  class="col-4 d-flex flex-row flexauto forallmore text-left"
                >
                  <div class="float-left mr-1">
                    <img src="assets/images/pdf.svg" width="18" />
                  </div>
                  <div>
                    <a
                      class="float-left pikclr pt-1 pl-1"
                      href="{{ expiredPlan.productTOS }}"
                      target="_blank"
                      >TOS</a
                    >
                  </div>
                </div>
                <div
                  class="
                    col-4
                    d-flex
                    flex-row
                    flexauto
                    forallmore
                    pr-0
                    text-left
                  "
                >
                  <div class="float-left mr-1">
                    <img src="assets/images/pdf.svg" width="18" />
                  </div>
                  <div>
                    <a
                      class="float-left pikclr pt-1 pl-1"
                      href="{{ expiredPlan.productYRAC }}"
                      target="_blank"
                      >YRAC</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex mt-1 p-2">
            <p class="font-weight-normal-calibre font15 lnhgt15 webview mt-3">
              Service Address: {{ expiryChangedAddress }} | ESI ID:
              {{ expiredPlanObj.esiid }}<br />
              Contract Term:
              {{ expiredPlanObj.createdDate | date: 'M/d/yyyy' }} -
              {{ expiredPlanObj.expirationDate | date: 'M/d/yyyy' }}*
            </p>
          </div>
          <p class="font-weight-normal-calibre font15 lnhgt15 mobileview mt-3">
            Service Address: {{ expiryChangedAddress }} <br />
            ESI ID: {{ expiredPlanObj.esiid }}<br />
            Contract Term: {{ expiredPlanObj.createdDate | date: 'M/d/yyyy' }} -
            {{ expiredPlanObj.expirationDate | date: 'M/d/yyyy' }}*
          </p>
        </div>
        <p class="font-weight-normal-calibre font13 lnhgt15 mt-2">
          *Contract Term dates provided herein are estimates. Be sure to consult
          your most recent energy bill to check for your actual contract
          expiration date.
        </p>
        <div class="col-12 text-center mt-4">
          <a
            *ngIf="showSlctAdd"
            class="pikclr planseladd"
            href="javascript:void(0)"
            data-toggle="modal"
            data-target="#addressModal"
            (click)="showAddressModal()"
            >View Past Plans</a
          >
        </div>
      </div>
    </div>
  </div>
</main>
<div
  *ngIf="addressModalVisible"
  class="modal fade"
  id="addressModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button
          type="button"
          class="close videoclose"
          data-dismiss="modal"
          aria-label="Close"
        >
          <!-- <span aria-hidden="true">&times;</span> -->
          <div class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="20" />
          </div>
        </button>
        <div class="mt-4 text-center">
          <h6 class="font22 filtertxt">
            Filter Your Plans by Service Address
          </h6>
        </div>
        <div
          class="mt-3 font-weight-normal-calibre addresscontentDiv {{ selectedAddressList.length >= 7 ? 'addresscontentScroll' : ''  }}"
          *ngIf="selectedAddressList.length > 0"
        >
          <ng-container *ngFor="let address of selectedAddressList">
            <div class="custom-control custom-radio mb-2" style="display: flex;    align-items: center;    gap: 13px;
            line-height: 1;">
              <div><input
                type="radio"
                name="group"
                id="{{address.esiid}}"
                style="cursor: pointer;"
                (change)="getAddress(address.billingAddress.userAddress,address.esiid)"
                [value]="address.billingAddress.userAddress"
              /></div>
              <div style="cursor: pointer;" (click)="SelectAddressfunction(address.esiid)">
              <span>{{
                address.billingAddress.userAddress.street_address +
                  ', ' +
                  (address.billingAddress.apartment == "" ? "" : address.billingAddress.apartment + ", ")
                  +
                  address.billingAddress.userAddress.city +
                  ', ' +
                  address.billingAddress.userAddress.state +
                  ', ' +
                  address.billingAddress.userAddress.zipcode + ' | '
              }}</span>
              <br/>
            <span>
              {{
              address.esiid}}</span>
            </div>
            </div>
          </ng-container>
        </div>
        <div class="text-right">
          <a
            class="pikclr font18 linhgt19 font-weight-normal-calibre"
            href="javascript:void(0)"
            (click)="submit()"
            >DONE</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
